import type { PluginWebManifest } from '@reflex/plugin-api/web';
import { BUG_SECRET_KEYS, CANNY_API_KEY, FEEDBACK_SECRET_KEYS } from './shared/platform.js';
import { SEND_FEEDBACK_COMMAND_HASH } from './shared/feedback-command.js';

export const FEEDBACK_PAGE_PATH = '/feedback';

export const feedbackWeb: PluginWebManifest = {
  routes: [
    {
      path: FEEDBACK_PAGE_PATH,
      componentPath: '@reflex/plugin-feedback/web/MyFeedbackPage',
    },
  ],
  globalUiElements: [
    {
      id: 'feedback-popover',
      componentPath: '@reflex/plugin-feedback/web/FeedbackPopover',
      alwaysAvailable: true,
      requiresServiceSecrets: [CANNY_API_KEY],
    },
  ],
  agentActions: [
    {
      label: 'Report bug',
      icon: 'Bug',
      componentPath: '@reflex/plugin-feedback/web/FeedbackAgentAction',
      alwaysAvailable: true,
      requiresServiceSecrets: [...BUG_SECRET_KEYS],
      placement: 'header-inline',
    },
  ],
  navItems: [
    {
      to: SEND_FEEDBACK_COMMAND_HASH,
      label: 'Send feedback',
      icon: 'Megaphone',
      group: 'user-menu',
      order: 30,
      alwaysAvailable: true,
      requiresServiceSecrets: [...FEEDBACK_SECRET_KEYS],
    },
    {
      // Sending feedback is an action (the row above opens the popover);
      // tracking what happened to it is a place, so it gets its own row next
      // to Profile and Settings. Being a real route in the `user-menu` group
      // is also what puts `/feedback` inside the Account takeover, so the page
      // opens fullscreen like the rest of the account surface.
      to: FEEDBACK_PAGE_PATH,
      label: 'My feedback',
      icon: 'MessageSquareHeart',
      group: 'user-menu',
      order: 31,
      alwaysAvailable: true,
      requiresServiceSecrets: [...FEEDBACK_SECRET_KEYS],
    },
    {
      to: SEND_FEEDBACK_COMMAND_HASH,
      label: 'Send feedback',
      icon: 'Megaphone',
      group: 'takeover-footer',
      alwaysAvailable: true,
      requiresServiceSecrets: [...FEEDBACK_SECRET_KEYS],
    },
  ],
  commands: [
    {
      label: 'Send feedback',
      to: SEND_FEEDBACK_COMMAND_HASH,
      icon: 'Megaphone',
      group: 'misc',
      alwaysAvailable: true,
      requiresServiceSecrets: [...FEEDBACK_SECRET_KEYS],
    },
    {
      label: 'My feedback',
      to: FEEDBACK_PAGE_PATH,
      icon: 'MessageSquareHeart',
      group: 'misc',
      alwaysAvailable: true,
      requiresServiceSecrets: [...FEEDBACK_SECRET_KEYS],
    },
  ],
  adminSetupComponent: {
    componentPath: '@reflex/plugin-feedback/web/FeedbackSetupPanel',
    label:
      'Paste the Canny API key as a service secret, then pick the Send feedback boards and the Report bug board.',
  },
};
